import { render, staticRenderFns } from "./ivsp.vue?vue&type=template&id=64ac95ca&scoped=true&"
import script from "./ivsp.vue?vue&type=script&lang=js&"
export * from "./ivsp.vue?vue&type=script&lang=js&"
import style0 from "./ivsp.vue?vue&type=style&index=0&id=64ac95ca&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ac95ca",
  null
  
)

export default component.exports